import { Button, Form } from "antd";
import React, { useState } from "react";
import FormInput from "../../components/FormInputs/FormInput";
import "./Login.scss";
import logo from "../../assets/images/I_Own_It_logo.png";
import FormPassword from "../../components/FormInputs/FormPassword";
import { USER_LOGIN } from "../../utils/apiPath";
import { postApi } from "../../utils/apiServices";
import { useNavigate } from "react-router-dom";
import ToastHelper from "../../services/ToastHelper";

const Login = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);

  const onFinish = async (values) => {
    setIsLoading(true);
    const payload = {
      email: values.email,
      password: values.password,
      roleId: 1,
    };

    try {
      const { statusCode, data, message, error } = await postApi(
        USER_LOGIN,
        payload
      );

      if (statusCode === 200) {
        navigate("/dashboard");
        localStorage.setItem("accessToken", data?.accessToken);
        ToastHelper.success("success");
      } else if (statusCode === 400) {
        ToastHelper.error(
          error || message || "An error occurred. Please try again."
        );
      } else {
        ToastHelper.error("Something went wrong. Please try again.");
      }
    } catch (err) {
      ToastHelper.error(
        "Failed to connect to the server. Please try again later."
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="loginpage">
      <div className="loginpage_container">
        <div className="loginpage_container_left">
          <div className="loginpage_container_left_elements">
            <div className="loginpage_container_left_elements_header">
              <img src={logo} alt="logo" />
              <div className="loginpage_container_left_elements_header_content">
                <h4>Login</h4>
                <p>Please enter your email and password</p>
              </div>
            </div>
            <Form form={form} layout="vertical" onFinish={onFinish}>
              <div className="form-grid">
                <FormInput
                  label="Email"
                  name="email"
                  type="email"
                  rules={[
                    { required: true, message: "Please enter your email" },
                  ]}
                  placeholder="Enter your email"
                />
                <FormPassword
                  label="Password"
                  name="password"
                  type="password"
                  rules={[
                    { required: true, message: "Please enter your password" },
                  ]}
                  placeholder="Enter your password"
                />
              </div>
              <div className="formsubmit">
                <Button type="primary" htmlType="submit" loading={isLoading}>
                  Login
                </Button>
              </div>
            </Form>
            {/* <div className="enrollbutton">
              <div className="enrollbutton_container">
                <p onClick={() => console.log("Forgot Password clicked")}>
                  Forgot Password?
                </p>
              </div>
            </div> */}
          </div>
        </div>
        {/* <div className="loginpage_container_right">
          <div className="loginpage_container_right_main">
            <div className="loginpage_container_right_main_content">
              <div className="loginpage_container_right_main_content_data">
                <div className="text">
                  <p>WELCOME TO</p>
                  <img src={logo} alt="logo" />
                </div>
                <div className="bottomtext">
                  <i>Your Best Experience, Ever!</i>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default Login;
